import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Divider,
  Grid,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import NavBar from '../../components/NavBar';
import SpecificationPresetList from '../../components/SpecificationPresetList';
import { TRANSLATION_FILES } from '../../constants/translation';

class List extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    return {
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = List.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = List.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Projects Settings')}
        />
        <Grid verticalAlign="middle" columns="equal" stackable>
          <Grid.Row>
            <Grid.Column>
              <Divider horizontal>{t('Specification Presets')}</Divider>
              <SpecificationPresetList
                loading={this.state.loading}
                type="projects"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(List);



// WEBPACK FOOTER //
// ./src/containers/ProjectSpecifications/List.jsx